module.exports = __webpack_public_path__ + "assets/images/monkey-dad_348a2db3804581a08a493f42d753d066.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-three/monkey-dad.png
// module id = 79
// module chunks = 0